import React, { useState } from "react";

export const useEditMode = () => {
  const [mode, setMode] = useState("R");

  const setRead = () => setMode("R");
  const setUpdate = () => setMode("U");
  const setCreate = () => setMode("C");

  return { mode, setRead, setUpdate, setCreate };
};
